import React, { useEffect, useState } from "react";
import CardInput from "../../components/CardInput";
import { getFullDomain } from "../../utils";

export default function Xendit(props) {
  const alert = props.alert;
  const [publicKey] = useState(props.authToken ?? props.publicKey);
  const currencyISO = props.currencyISO;
  const orderId = props.tranId ?? props.orderId;
  const setIsLoading = props.setIsLoading;
  const onSubmit = async (data) => {
    setIsLoading(true);
    const { cardNumber, cardExpiryDate, cardCVC, cardHolder, billingEmail } =
      data;
    const [cardExpiryMonth, cardExpiryYear] = cardExpiryDate.split(" / ");
    const domain = getFullDomain();
    const returnUrlSuccess = `${domain}/success`;
    const returnUrlFailure = `${domain}/failure`;
    window.Xendit.card.createToken(
      {
        card_number: cardNumber,
        card_exp_month: cardExpiryMonth,
        card_exp_year: `20${cardExpiryYear}`,
        channel_properties: {
          success_return_url: returnUrlSuccess,
          failure_return_url: returnUrlFailure,
        },
        success_return_url: returnUrlSuccess,
        failure_return_url: returnUrlFailure,
        card_cvn: cardCVC,
        is_multiple_use: true,
        should_authenticate: true,
        currency: currencyISO,
        on_behalf_of: "",
        billing_details: undefined,
        token_id: "",
        external_id: orderId,
        card_holder_email: billingEmail,
        card_holder_name: cardHolder,
      },
      (err, resp) => {
        if (err) {
          if (err.message) {
            alert(err.message);
          } else {
            alert("An error occurred while processing the payment.");
          }
        } else {
          if (resp.status === "REQUIRES_ACTION") {
            const action = resp.actions.find(
              (action) => action.action === "AUTH"
            );
            window.location.href = action.url;
          }
          window.Xendit.card.createAuthentication(
            {
              amount: "0",
              token_id: resp.id,
              card_cvn: cardCVC,
              external_id: orderId,
            },
            (err, resp) => {
              console.log("Authentication", resp, err);
              if (err) {
                if (err.message) {
                  alert(err.message);
                } else {
                  alert("An error occurred while processing the payment.");
                }
              } else {
                window.location.href = resp.payer_authentication_url;
              }
            }
          );
        }
        console.log("CreateMethod", resp, err);
        setIsLoading(false);
      }
    );
  };

  useEffect(() => {
    if (publicKey) {
      const script = document.createElement("script");
      script.src = "https://js.xendit.co/v1b/xendit.min.js";
      script.async = true;
      document.body.appendChild(script);

      script.onload = () => {
        window.Xendit.setPublishableKey(publicKey);
      };
      return () => {
        document.body.removeChild(script);
      };
    } else {
      alert("Payment gateway have not step up!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [publicKey]);

  return (
    <div>
      <CardInput onSubmit={onSubmit} configGateway={props} />
    </div>
  );
}
